<template>
  <div class="container mescroll-touch" id="container">
    <div class="borderTop"></div>
    <div v-if="ashow == true" class="shlog">
      <div class="shin">
        <img class="shlog1" src="@/assets/images/share_action_icon@2x.png" />
        <img class="shlog2" src="@/assets/images/pic_action_icon@2x.png" />
        <div class="shlog4">点击右上角“...”，分享到</div>
        <div class="shlog3">
          <img class="sslog" src="@/assets/images/wx_action_icon@2x.png" />
          <span>微信好友或</span>
          <img class="sslog1" src="@/assets/images/pyq_action_icon@2x.png" />
          <span>微信朋友圈~</span>
          <div class="known" @click="ashow = false">知道了</div>
        </div>
      </div>
    </div>
    <div class="title">{{ list.Title }}</div>
    <div class="timetab">
      <div class="time">
        {{ list.CreateTime | dateFilter(list.CreateTime) }}
      </div>
    </div>
    <div class="speakerBox" v-show="list.SpeakerId" @click="toPersonal(list.SpeakerId)">
      <div class="speakerIcon">
        <img src="@/assets/images/headSculpture1.png" alt="" />
      </div>
      <div class="speakerInfo">
        <div class="speakerInfo_top">
          <span class="speakerName">{{ list.Speaker }}</span>
          <span class="positionalName" v-if="list.SPositional">{{ list.SPositional }}</span>
        </div>
        <div class="speakerHospital">{{ list.SHospital }}</div>
      </div>
    </div>
    <div class="siconBox">
      <div class="siconBox_left">
        <div class="sicon">
          <img
            style="vertical-align: middle; margin-right: 2px"
            src="@/assets/images/browse_comm_icon@2x.png"
          />
          <span style="vertical-align: middle">{{ list.WatchCount }}</span>
        </div>
        <div class="sicon">
          <img
            style="width: 1.1em; vertical-align: middle; margin-right: 2px"
            src="@/assets/images/like_comm_icon@2x.png"
          />
          <span style="vertical-align: middle">{{ list.LikeCount }}</span>
        </div>
      </div>
      <div class="ForwardPosterBox" @click="generatePoster">
        <img class="relayIcon" src="../../assets/images/relay.png" />
        <span>转发</span>
        <img class="newGif" v-if="isNew" src="../../assets/images/newGif.gif" />
      </div>
    </div>

    <div class="content1" v-show="list.Type == 1">
      <div id="playerBox" style="width: 100%; height: 320px;">
        <video
          id="player-container-id"
          style="width: 100%; height: 100%;"
          preload="auto"
          playsinline=""
          webkit-playsinline=""
          x5-playsinline=""
        ></video>
      </div>
      <div class="anchorPointBox" v-if="list.lstTVMA && list.lstTVMA.length > 0">
        <div class="anchorPointWrapper">
          <div class="anchorPointList">
            <div class="anchorPoint_item" :class="{'anchorPoint_item_active' : AnchorPointIndex == index}" v-for="(item, index) in list.lstTVMA" :key="index" @click="videoAnchorPoint(index, item.TimeOffset, item.Id)">
              <div class="anchorPoint_item_content">
                <img class="anchorPoint_icon" :src="AnchorPointIndex == index ? require('@/assets/images/anchorPoint_play_icon1.png') : require('@/assets/images/anchorPoint_icon.png')" />
                <span class="anchorPoint_time">{{ item.Minute }}</span>
                <span class="anchorPoint_title" :data-text="item.Name">{{ item.Name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="detail">
        <div
          class="VContent"
          v-html="list.VContent"
        ></div>
        <div
          class="banner"
          v-html="list.ImageText"
        >
        </div>
      </div>
    </div>

    <div class="content2" v-if="list.Type == 2">
      <div class="detail">
        <div
          class="banner"
          v-html="list.ImageText"
        >
        </div>
      </div>
    </div>

    <div class="sourceBox" @click="toSource(list.SourceLink)" v-if="list.SourceContent && list.SourceLink">
      <p class="sourceTips">以上内容来源于{{ list.SourceContent }}，点击查看来源</p>
      <div class="sourceFlexBox">
        <img class="sourceLogo" :src="list.SourceLog" />
        <div class="sourceTitle van-multi-ellipsis--l2">{{ list.SourceContent }}</div>
        <img class="sourceIcon" src="@/assets/images/icon_right1.png" />
      </div>
    </div>

    <div class="line"></div>

    <div class="rowbtn">
      <span class="headline">评论</span>
      <div class="plbtn" @click="showPopup">
        <span>评论</span>
      </div>
    </div>

    <van-popup
      v-model="show"
      closeable
      position="bottom"
      :style="{ height: '28%' }"
      class="plPopup"
    >
      <van-cell-group class="plinput">
        <van-field v-model="plform.Content" type="textarea" rows="3" autosize placeholder="留言中不得出现任何违反法律法规，或侮辱，诽谤他人等侵害他人合法权益的内容。仅代表个人观点，与本公司无关，请对您发表的言论负责。" />
      </van-cell-group>
      <div class="rateupload" @click="plupload">提交</div>
    </van-popup>

    <div class="plmain">
      <div
        class="plrow noComment"
        v-if="Object.keys(CommentList).length == 0"
      >
        <img src="@/assets/images/none_comm@2x.png" />
        <span>暂无评论</span>
      </div>
      <div
        class="plrow"
        v-else
        v-for="(item, index) in CommentList"
        :key="index"
      >
        <div class="pltop">
          <!-- <div class="tx">
            <img class="plicon" style="" :src="item.Headimgurl" />
          </div> -->
          <div class="plname">{{ item.CusRealName }}</div>
          <div class="pltime">{{ item.Time | dateFilter(item.Time) }}</div>
        </div>
        <div class="pltext">
          {{ item.Content }}
        </div>

        <div class="pldz">
          <img
            class="plicon"
            style=""
            v-if="item.LikeState == false"
            src="@/assets/images/like.png"
            @click="pldz(item.Id, index)"
          />
          <img
            class="plicon"
            style=""
            v-else
            src="@/assets/images/like_active.png"
            @click="plqxdz(item.Id, index)"
          />
          <span>{{ item.LikeCount }}</span>
        </div>
      </div>
    </div>

    <div class="line"></div>

    <div class="relatedRecommendation">
      <div class="relatedTitle">
        <img class="icon" src="@/assets/images/related.png"/>
        <span>相关推荐</span>
      </div>
      <div class="relatedContent">
        <template v-if="recommendArticleList && recommendArticleList.length > 0">
          <div class="articleList" v-for="(item, index) in recommendArticleList" :key="index" @click="toContentPage(item.Id, item.Type)">
            <div class="articleCover">
              <img :src="item.Thumbnail" alt="" />
            </div>
            <div class="articleInfo">
              <p class="articleTitle van-multi-ellipsis--l2">{{ item.Title }}</p>
              <!-- <div class="articleData">
                <div class="operateBox">
                  <div class="operateItem">
                    <img class="operateIcon watch" src="@/assets/images/personal_watch_active.png" alt="" />
                    <span>{{ item.WatchCount }}</span>
                  </div>
                  <div class="operateItem">
                    <img class="operateIcon like" src="@/assets/images/personal_like_active.png" alt="" />
                    <span>{{ item.LikeCount }}</span>
                  </div>
                  <div class="operateItem">
                    <img class="operateIcon collect" src="@/assets/images/personal_collect_active.png" alt="" />
                    <span>{{ item.CollectCount }}</span>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </template>
        <div class="plrow noComment" v-else>
          <img src="@/assets/images/none_comm@2x.png" />
          <span>暂无相关推荐</span>
        </div>
      </div>
    </div>

    <div class="toTop" @click="toTop">
      <a href="javascript:void(0)">
        <img src="@/assets/images/top_comm_icon@2x.png" />
      </a>
    </div>

    <img class="gobackXG" v-if="$route.query.source == 'xg'" @click="toLiveHome" src="@/assets/images/gobackXG.png" />

    <div class="bottombar">
      <div class="bottomrow" @click="goback">
        <div>
          <img
            class="bottomimg"
            src="@/assets/images/back.png"
          />
        </div>
        <div class="bottomtext">返回</div>
      </div>
      <div class="bottomrow" @click="adddz" v-if="dzyes == false">
        <div>
          <img
            class="bottomimg"
            src="@/assets/images/likes.png"
          />
        </div>
        <div class="bottomtext">点赞</div>
      </div>
      <div class="bottomrow" @click="deldz" v-else>
        <div>
          <img
            class="bottomimg"
            src="@/assets/images/likesActive.png"
          />
        </div>
        <div class="bottomtext">点赞</div>
      </div>
      <template>
        <div class="bottomrow" @click="addsc" v-if="scyes == false">
          <div>
            <img
              class="bottomimg"
              src="@/assets/images/collect_ny_icon_nor@2x.png"
            />
          </div>
          <div class="bottomtext">收藏</div>
        </div>
        <div class="bottomrow" @click="delsc" v-else>
          <div>
            <img
              class="bottomimg"
              src="@/assets/images/collect_ny_icon_alt@2x.png"
            />
          </div>
          <div class="bottomtext">收藏</div>
        </div>
      </template>
      <!-- <div class="bottomrow" @click="sharefunc">
        <div>
          <img
            class="bottomimg"
            src="@/assets/images/share_ny_icon_nor@2x.png"
          />
        </div>
        <div class="bottomtext">转发</div>
      </div> -->
    </div>

    <!-- 视频播放弹框 -->
    <div class="videoPopupBox">
      <van-popup v-model="videoPopupShow" :overlay-style="{background: 'black'}" :get-container="getContainer" @closed="videoPopupClosed">
        <div id="videoPopupDiv" style="width: 100%; height: 320px; background-color: black;">
          <video
            id="player-popup-id"
            style="width: 100%; height: 100%;"
            preload="auto"
            playsinline=""
            webkit-playsinline=""
            x5-playsinline=""
          ></video>
        </div>
      </van-popup>
    </div>

    <!-- 海报转发 -->
    <van-popup class="PosterPopup" v-model="PosterShow" :close-on-click-overlay="false" @opened="generateImageOpened">
        <div class="close" @click="PosterShow = false">
          <van-icon class="closeIcon" name="cross" />
        </div>
        <div class="PosterBox">
          <div class="generateImageBox" ref="generateImageBox" v-if="!PosterPhoto">
            <img class="PosterImg" :src="list.Thumbnail" />
            <div class="QrcodeBox">
              <img class="QrcodeFont" src="@/assets/images/font1.png" />
              <img class="Qrcode" crossOrigin="anonymous" v-if="list.QRCode" :src="list.QRCode" />
              <img class="QrcodeFont" src="@/assets/images/font2.png" />
            </div>
          </div>
          <img class="PosterPhoto" v-else :src="PosterPhoto" alt="">
          <p class="tips">请长按保存图片到手机后转发</p>
        </div>
    </van-popup>

    <!-- <Questionnaire v-if="showQuestionnaire" :showType="2" :questionId="questionId" :correlationId="correlationId" :pageType="pageType" /> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Dialog, ImagePreview } from "vant";
import wx from "weixin-js-sdk";
import utils from "../../common/utils/utils";
import html2canvas from 'html2canvas';
// import Questionnaire from '../../components/questionnaire.vue';
export default {
  name: "ContentPage",
  data() {
    return {
      showQuestionnaire: false,
      hasPath: '',
      appId: "",
      timestamp: "",
      nonceStr: "",
      signature: "",
      list: {},
      recommendArticleList: [],
      Comment: {},
      CommentList: [],
      watched: {},
      dzt: {},
      ztmain: [],
      id: 0,
      checked: false,
      current: 0,
      show: false,
      customerid: "",
      plform: {
        ArticleId: 0,
        CustomerId: "",
        Type: 4,
        Content: "",
      },
      CommentLikelist: {
        CustomerId: "",
        CommentId: "",
      },
      dzyes: false,
      scyes: false,
      dzshow: false,
      scshow: false,
      getstar: {},
      stars: [],
      ratebtnshow: 0,
      shareurl: {},
      weixinvalue: {
        appId: "",
        timestamp: "",
        noncStr: "",
        signature: "",
      },
      utype: "",
      backlog: {
        ShareUid: 0,
        SeeUid: 0,
        ShareUri: "",
        Code: "",
        ShareId: 0,
        seeType: "",
      },
      sharefrom: 0,
      sharecode: "",
      ssurl: "",
      timepoint: {
        ArticleId: "",
        Type: "",
        Date: "",
      },
      timer: null,
      pathname: null,
      player: null,
      initPlayer: true,
      AnchorPointIndex: null,
      ashow: false,
      kpng: require("../../assets/images/k.png"),
      IsGetFansUser: false,
      IsFansUser: null,
      videoPopupShow: false,
      videoInfo: null,
      isNew: false,
      PosterShow: false,
      PosterPhoto: ''
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    code() {
      return this.$route.query.code;
    },
    sourceType() {
      return this.$route.query.sourceType
    },
    sourceId() {
      return this.$route.query.sourceId
    }
  },
  components: {
    // Questionnaire
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.hasPath = from.path;
    });
  },
  created() {
    // this.getInfo();
    this.getRecommendArticle();
    this.getComment();
    this.dzzt();
    // this.initShare();
    this.fromLog();
  },
  mounted() {
  },
  activated() {
    // this.getQuestion();
    this.getInfo();
    this.enter();
  },
  deactivated() {
    if (this.player) {
      this.player.dispose();
    }

    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }

    if (this.VideoTimer) {
      clearInterval(this.VideoTimer);
      this.VideoTimer = null;
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }

    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }

    if (this.VideoTimer) {
      clearInterval(this.VideoTimer);
      this.VideoTimer = null;
    }
  },
  destroyed() {
    if (this.player) {
      this.player.dispose();
    }

    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }

    if (this.VideoTimer) {
      clearInterval(this.VideoTimer);
      this.VideoTimer = null;
    }
  },
  methods: {
    getQuestion() {
      this.$axios.post("/Api/Api/Web/Question/Q").then(res => {
        let data = res.Data;
        const foundUrl = data.find(item => item.url == '/contentPage' && item.Id == this.$route.query.id && item.IsPopUp);
        if(foundUrl) {
          this.showQuestionnaire = true;
          this.questionId = foundUrl.QId;
          this.correlationId = foundUrl.Id;
          this.pageType = foundUrl.Type;
        }
      });
    },
    getContainer() {
      return document.querySelector('.videoPopupBox');
    },
    //记录分享人行为数据
    fromLog() {
      //alert("记录分享人行为数据-开始");
      //从url参数中获取分享人id和code
      this.utype = this.$route.query.seetype;
      //alert("记录分享人行为数据-utype："+this.utype);
      if (this.utype == 2) {
        //alert("记录分享人行为数据-进入-utype=2");
        //sharefrom  sharecode
        this.sharefrom = this.$route.query.shareuid;
        this.sharecode = this.$route.query.code;
        this.sharelog();
      }
    },
    // 初始化直播
    initVideo() {
      let Options = {};
      if(this.list.fileid) {
        Options = {
          fileID: this.list.fileid,
          appID: this.list.appid,
          psign: this.list.psign,
          licenseUrl: 'https://license.vod2.myqcloud.com/license/v2/1307224350_1/v_cube.license'
        };
        this.player = this.TCPlayer("player-container-id", Options, {
          app_Play_Id: this.list.app_Play_Id,
          app_Id: 'EthiconLive',
          user_Id: this.list.user_Id,
          video_Id: this.list.Id
        },{
          Id: this.userInfo.Id,
          UserName: this.userInfo.UserName,
          HospitalTitle: this.userInfo.HospitalTitle,
          PositionalName: this.userInfo.PositionalName,
          SubjectName: this.userInfo.SubjectName
        }, this.list.Title, this.list.videoSize, this.list.fileid, 10).player;
      } else {
        Options = {
          playbackRates: [0.5, 1, 1.5, 2],
          licenseUrl: 'https://license.vod2.myqcloud.com/license/v2/1307224350_1/v_cube.license'
        };
        this.player = this.TCPlayer("player-container-id", Options).player;
        this.player.src(this.list.Video);
      }
      this.player.on("play", () => {
        // console.log('播放', this.VideoTimer)
        let d = new Date().getTime();
        this.$axios.post("/Api/Api/Web/BuriedPoint/AddDur", {
          ArticleId: this.list.Id,
          Type: 2,
          Date: d,
        }).then((res) => {
          if (!this.VideoTimer) {
            this.VideoTimer = setInterval(() => {
              this.UpdateDur(res.Data);
            }, 10000);
          }
        });
      });
      this.player.on("pause", () => {
        // console.log('暂停', this.VideoTimer)
        if (this.VideoTimer) {
          clearInterval(this.VideoTimer);
          this.VideoTimer = null;
        }
      })
    },
    UpdateDur(Id) {
      let time = new Date().getTime();
      this.$axios.post("/Api/Api/Web/BuriedPoint/UpdateDur", {
        Id: Id,
        Date: time,
      });
    },
    videoAnchorPoint(index, second, id) {
      this.AnchorPointIndex = index;
      this.player.play();
      this.player.currentTime(second);
      this.$axios.post("/Api/Api/Web/Article/Handle", {
        ArticleId: parseInt(this.id),
        CustomerId: this.userInfo.Id,
        Type: 10,
        Source: this.sourceType ? this.sourceType : 0,
        externalID: this.sourceId ? this.sourceId : '',
        Mid: id
      }).then((res) => {});
    },
    getInfo() {
      this.id = typeof this.$route.query.id !== "undefined" ? this.$route.query.id : 0;
      if (this.id > 0) {
        this.$axios
          .post("/Api/Api/Web/Article/GetArticleDetile?id=" + this.id)
          .then((res) => {
            let data = res.Data;
            if(data.IsDeleted) {
              this.$router.replace('/noContent');
            } else {
              this.list = data;
              wx.miniProgram.postMessage({
                data: {
                  share: {
                    title: data.Title,
                    imageUrl: '',
                    path: `/pages/oneSurgery/oneSurgery?url=${encodeURIComponent(process.env.VUE_APP_BASE_URL + `/contentPage?id=${this.id}&sourceType=7`)}`,
                    contentId: this.id
                  }
                }
              })

              if (data.Type == "1") {
                let container = document.getElementById('player-container-id');
                if (!container) {
                  const video = document.createElement('video');
                  video.id = 'player-container-id';
                  video.style = 'width: 100%; height: 100%;';
                  video.setAttribute('preload', 'auto');
                  video.setAttribute('playsinline', '');
                  video.setAttribute('webkit-playsinline', '');
                  video.setAttribute('x5-playsinline', '');
                  
                  const playerBox = document.getElementById('playerBox');
                  if (playerBox) {
                    playerBox.appendChild(video);
                  }
                  this.initVideo();
                } else {
                  this.initVideo();
                }
              }
            }
          });
      }
    },
    getRecommendArticle() {
      this.id = typeof this.$route.query.id !== "undefined" ? this.$route.query.id : 0;
      this.$axios.post("/Api/Api/web/Article/GetArtDetile?id=" + this.id).then((res) => {
        this.recommendArticleList = res.Data.RecommendList;
      })
    },
    initShare() {
      let that = this;
      const entryLink = utils.getEntryLink();
      that.$axios
        .get("/Api/Api/web/WechatHelper/GetWechat?backUrl=" + entryLink)
        .then((res) => {
          wx.config({
            debug: false,
            appId: res.Data.AppId,
            timestamp: res.Data.TimesTamp,
            nonceStr: res.Data.NonceStr,
            signature: res.Data.She1Str,
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
          });
          wx.checkJsApi({
            jsApiList: [
              // 所有要调用的 API 都要加到这个列表中
              "updateAppMessageShareData", // 分享到朋友圈接口
              "updateTimelineShareData", //  分享到朋友接口
            ],
            success: async function (res) {
              var url = await that.getShareUrl();
              wx.ready(() => {
                wx.updateAppMessageShareData({
                  title: that.list.Title,
                  link: url,
                  desc: that.list.Details ? that.list.Details : '',
                  imgUrl: "https://wcwechat.jjmc.cn/" + that.kpng,
                  success: function (res) {},
                });
                wx.updateTimelineShareData({
                  title: that.list.Title,
                  link: url,
                  desc: that.list.Details ? that.list.Details : '',
                  imgUrl: "https://wcwechat.jjmc.cn/" + that.kpng,
                  success: function (res) {},
                });
              });
            },
          });
        });
    },

    sharefunc() {
      let that = this;
      //
      //这里提示用户去右上角分享
      //
      that.ashow = true;
      //记录分享日志
      that.sharelog();
    },

    getShareUrl() {
      let that = this;
      this.shareurl.customerid = this.userInfo.Id;      
      var shurl = window.location.href;
      var shindex = shurl.indexOf("&seetype");
      if (shindex > -1) {
        shurl = shurl.substr(0, shindex);
      }
      //console.log("85825225",window.location.href,shurl)
      this.shareurl.url = encodeURIComponent(shurl);
      return new Promise((resolve) => {
        that.$axios
          .get(
            "/Api/Api/web/ShareLog/GetShareUrl?url=" +
              that.shareurl.url +
              "&customerid=" +
              this.shareurl.customerid
          )
          .then((res) => {
            resolve(res.Data.Url);
          });
      });
    },

    sharelog() {
      //alert("分享记录-开始");
      let that = this;
      that.backlog = {
        ShareUid: this.sharefrom,
        SeeUid: this.userInfo.Id,
        ShareUri: window.location.href,
        Code: this.sharecode,
        ShareId: this.id,
        seeType: this.utype,
        Type: 1
      };
      //alert("分享记录-拿到信息"+JSON.stringify(that.backlog));

      that.$axios
        .post("/Api/Api/Web/ShareLog/AddShare", that.backlog)
        .then((res) => {});
    },
    getComment() {
      this.Comment.ArticleId =
        typeof this.$route.query.id !== "undefined" ? this.$route.query.id : 0;
      this.Comment.CustomerId = this.userInfo.Id;
      let that = this;
      that.$axios
        .post("/Api/Api/Web/Article/GetComment", this.Comment)
        .then((res) => {
          that.CommentList = res.Data;
        });
    },
    onChange(index) {
      this.current = index;
    },
    showPopup() {
      this.show = true;
    },
    plupload() {
      this.plform.ArticleId =
        typeof this.$route.query.id !== "undefined" ? this.$route.query.id : 0;
      this.plform.CustomerId = this.userInfo.Id;
      let that = this;
      if(this.plform.Content) {
      that.$axios
        .post("/Api/Api/Web/Article/AddComment", this.plform)
        .then((res) => {
          if (res.RetCode == "10000") {
            this.$axios.post('/Api/Api/Web/Article/Handle', {
              ArticleId: parseInt(this.id),
              CustomerId: this.userInfo.Id,
              type: 4,
              Source: this.sourceType ? this.sourceType : 0,
              externalID: this.sourceId ? this.sourceId : ''
            }).then((res) => {});
            
            Dialog.alert({
              message: "提交成功，审核通过后可以看到该评论",
            }).then(() => {
              this.show = false;
              this.plform.Content = '';
            });
          }
        });
      } else {
        this.$toast.fail('内容不能为空');
      }
    },
    pldz(id, index) {
      this.CommentLikelist.CustomerId = this.userInfo.Id;
      this.CommentLikelist.CommentId = id;
      this.CommentList[index].LikeState = true;
      this.CommentList[index].LikeCount++;
      let that = this;
      that.$axios
        .post("/Api/Api/Web/Article/AddCommentLike", this.CommentLikelist)
        .then((res) => {
          // this.list.CommentList.LikeState = true;
          // this.getComment();
        });
    },
    plqxdz(id, index) {
      this.CommentLikelist.CustomerId = this.userInfo.Id;
      this.CommentLikelist.CommentId = id;
      this.CommentList[index].LikeState = false;
      this.CommentList[index].LikeCount--;
      let that = this;
      that.$axios
        .post("/Api/Api/Web/Article/delCommentLike", this.CommentLikelist)
        .then((res) => {
          // this.list.CommentList.LikeState = true;
          // this.getComment();
        });
    },
    dzzt() {
      this.dzt.ArticleId =
        typeof this.$route.query.id !== "undefined" ? this.$route.query.id : 0;
      this.dzt.CustomerId = this.userInfo.Id;
      let that = this;
      that.$axios
        .post("/Api/Api/Web/Article/HandleState", this.dzt)
        .then((res) => {
          this.ztmain = res.Data;
          for (var i = 0; i < this.ztmain.length; i++) {
            if (this.ztmain[i].type == "3" && this.ztmain[i].State == true) {
              this.dzyes = true;
              this.dzshow = true;
            }
            if (this.ztmain[i].type == "2" && this.ztmain[i].State == true) {
              this.scyes = true;
              this.scshow = true;
            }
          }
          this.isNew = !res.Data.some(item => item.type == 11);
        });
    },

    timeline() {
      let that = this;
      let d = new Date().getTime();
      this.timepoint.Type = "1";
      this.timepoint.ArticleId = this.list.Id;
      this.timepoint.Date = d;
      that.$axios
        .post("/Api/Api/Web/BuriedPoint/AddDur", this.timepoint)
        .then((res) => {
          if (!this.timer) {
            this.timer = setInterval(() => {
              let time = new Date().getTime();
              that.$axios.post("/Api/Api/Web/BuriedPoint/UpdateDur", {
                Id: res.Data,
                Date: time,
              });
            }, 10000);
          }
        });
    },
    enter() {
      this.$axios.post("/Api/Api/Web/Article/Handle", {
        ArticleId: parseInt(this.id),
        CustomerId: this.userInfo.Id,
        type: 1,
        Source: this.sourceType ? this.sourceType : 0,
        externalID: this.sourceId ? this.sourceId : ''
      }).then((res) => {
        if (!this.timer && res.Data != 0) {
          this.timer = setInterval(() => {
            this.$axios.post("/Api/Api/Web/Article/ABUpdateTime?id=" + res.Data).then(() => {});
          }, 10000);
        }
      });
    },
    adddz() {
      this.dzyes = true;
      this.$axios.post("/Api/Api/Web/Article/Handle", {
        ArticleId: parseInt(this.id),
        CustomerId: this.userInfo.Id,
        type: 3,
        Source: this.sourceType ? this.sourceType : 0,
        externalID: this.sourceId ? this.sourceId : ''
      }).then((res) => {
        // this.dzzt();
        // this.dzshow = true;
        // this.list.CommentList.LikeState = true;
      });
    },
    deldz() {
      this.watched.ArticleId =
        typeof this.$route.query.id !== "undefined" ? this.$route.query.id : 0;
      this.watched.CustomerId = this.userInfo.Id;
      this.watched.type = "3";
      this.dzyes = false;
      let that = this;
      that.$axios
        .post("/Api/Api/Web/Article/DelHandle", this.watched)
        .then((res) => {
          // this.dzyes = false;
          // this.dzzt();
          // this.list.CommentList.LikeState = true;
        });
    },
    addsc() {
      this.scyes = true;
      this.$axios.post("/Api/Api/Web/Article/Handle", {
        ArticleId: parseInt(this.id),
        CustomerId: this.userInfo.Id,
        type: 2,
        Source: this.sourceType ? this.sourceType : 0,
        externalID: this.sourceId ? this.sourceId : ''
      }).then((res) => {
        // this.scshow = true;
        // this.dzzt();
        // this.list.CommentList.LikeState = true;
      });
    },
    delsc() {
      this.watched.ArticleId =
        typeof this.$route.query.id !== "undefined" ? this.$route.query.id : 0;
      this.watched.CustomerId = this.userInfo.Id;
      this.watched.type = "2";
      this.scyes = false;
      let that = this;
      that.$axios
        .post("/Api/Api/Web/Article/DelHandle", this.watched)
        .then((res) => {
          // this.scyes = false;
          // this.dzzt();
          // this.list.CommentList.LikeState = true;
        });
    },
    toTop() {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    },
    toLiveHome() {
      wx.miniProgram.navigateTo({url: '/pages/liveHome/liveHome'})
    },
    goback() {
      if(this.hasPath == '/' ) {
        this.$router.push('/home');
        return;
      }
      this.$router.go(-1);
    },
    imagePreview(e) {
      if (e.target.nodeName == "IMG") {
        if(e.target.dataset.fileid) {
          this.videoPopupShow = true;
          this.getVideo(e.target.dataset.fileid);
        } else {
          ImagePreview({
            images: [e.target.currentSrc],
            maxZoom: 10,
            showIndex: false,
            loop: false,
          });
        }
      } else {
        return;
      }
    },
    getVideo(fileid) {
      this.$axios.get('/Api/api/Web/Article/GetUI?vfid=' + fileid).then(res => {
        this.videoInfo = res.Data;
        this.initPopupVideo();
      })
    },
    initPopupVideo() {
      let Options = {};
      if(this.videoInfo) {
        Options = {
          fileID: this.videoInfo.fileid,
          appID: this.videoInfo.appid,
          psign: this.videoInfo.psign,
          licenseUrl: 'https://license.vod2.myqcloud.com/license/v2/1307224350_1/v_cube.license'
        };
        this.popupPlayer = this.TCPlayer('player-popup-id', Options, {
          app_Play_Id: this.videoInfo.app_Play_Id,
          app_Id: 'EthiconLive',
          user_Id: this.videoInfo.user_Id,
          video_Id: 0
        },{
          Id: this.userInfo.Id,
          UserName: this.userInfo.UserName,
          HospitalTitle: this.userInfo.HospitalTitle,
          PositionalName: this.userInfo.PositionalName,
          SubjectName: this.userInfo.SubjectName
        }, this.videoInfo.Name, this.videoInfo.videoSize, this.videoInfo.fileid).player;
      }
    },
    videoPopupClosed() {
      if(this.popupPlayer) {
        this.popupPlayer.dispose();
        const video = document.createElement('video');
        video.id = 'player-popup-id';
        video.style = 'width: 100%; height: 100%;';
        video.preload = 'auto';
        document.getElementById('videoPopupDiv').appendChild(video);
      }
    },
    toRetArticle(id, type) {
      this.$router.push({
        path: 'contentPage',
        query: {
          id: id,
          type: type
        }
      });
    },
    toSource(link) {
      this.$axios.post("/Api/Api/Web/Article/Handle", {
        ArticleId: parseInt(this.id),
        CustomerId: this.userInfo.Id,
        Type: 12,
        Source: this.sourceType ? this.sourceType : 0,
        externalID: this.sourceId ? this.sourceId : ''
      }).then((res) => {});
      location.href = link;
    },
    toPersonal(id) {
      this.$router.push({
        path: 'Personal',
        query: {
          id: id
        }
      });
    },
    generatePoster() {
      this.PosterShow = true;
      this.$axios.post("/Api/Api/Web/Article/Handle", {
        ArticleId: parseInt(this.id),
        CustomerId: this.userInfo.Id,
        Type: 11,
        Source: this.sourceType ? this.sourceType : 0,
        externalID: this.sourceId ? this.sourceId : ''
      }).then((res) => {
        this.dzzt();
      });
    },
    // generateImageOpened() {
    //   let toast = this.$toast.loading({
    //     message: '生成中...',
    //     forbidClick: true,
    //   });
    //   html2canvas(this.$refs.generateImageBox, {
    //     useCORS: true
    //   }).then((canvas) => {
    //     this.PosterPhoto = canvas.toDataURL("image/png");
    //     toast.clear();
    //   });
    // },
    generateImageOpened() {
      let toast = this.$toast.loading({
        message: '生成中...',
        forbidClick: true,
      });
      
      // 等待所有图片加载完成
      this.$nextTick(async () => {
        const images = this.$refs.generateImageBox.querySelectorAll('img');
        const imagePromises = Array.from(images).map(img => {
          return new Promise((resolve) => {
            if (img.complete && img.naturalHeight !== 0) {
              resolve();
            } else {
              img.onload = resolve;
              img.onerror = resolve; // 即使出错也继续
            }
          });
        });
        
        try {
          // 等待所有图片加载（或出错）
          await Promise.all(imagePromises);
          
          // 给一个延迟确保 DOM 稳定
          await new Promise(resolve => setTimeout(resolve, 500));
          
          html2canvas(this.$refs.generateImageBox, {
            useCORS: true,
            allowTaint: true, // 允许 tainted canvas
            backgroundColor: null, // 透明背景
            scale: 2, // 提高清晰度
          }).then((canvas) => {
            this.PosterPhoto = canvas.toDataURL("image/png");
            toast.clear();
          }).catch(error => {
            console.error('html2canvas 错误:', error);
            toast.clear();
            this.$toast('生成海报失败，请重试');
          });
          
        } catch (error) {
          toast.clear();
          console.error('图片等待错误:', error);
        }
      });
    },
    toContentPage(id, type) {
      if(type == 3) {
        this.$router.push({
          path: 'liveDetails',
          query: {
            id: id,
            sourceType: 6,
            sourceId: this.id
          }
        });
      } else {
        this.$router.push({
          path: 'contentPage',
          query: {
            id: id,
            type: type,
            sourceType: 6,
            sourceId: this.id
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 100%;
  padding-bottom: 8em;
  box-sizing: border-box;
  position: relative;
  -webkit-text-size-adjust: none;
  background-color: #F9F8F7;
}

.borderTop {
  width: 100%;
  height: 10px;
  background-image: url('../../assets/images/bg_comm_png@2x.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.line {
  width: 90%;
  height: 2px;
  border-radius: 2px;
  margin: 0 auto;
  background-image: url('../../assets/images/bg_comm_png@2x.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.title {
  width: 90%;
  margin: 0.5em auto;
  font-size: 20px;
  font-weight: bold;
  padding-top: 0.5em;
  color: #564C47;
}

.timetab {
  position: relative;
  margin: 1em auto;
}

.time {
  width: 90%;
  margin: 0.5em auto;
  font-size: 12px;
  color: #564C47;
}

.fontSize {
  display: block;
  position: absolute;
  right: 2%;
  top: 50%;
  font-size: 0.9em;
  transform: translatey(-50%);
  color: #8b8b8b;
  vertical-align: middle;
  img {
    width: 4em;
    vertical-align: middle;
  }
}

.siconBox {
  display: flex;
  justify-content: space-between;
  width: 90%;
  margin: 0 auto;
}
.siconBox_left {
  display: flex;
}
.sicon {
  display: flex;
  align-items: center;
  margin-right: 10px;
  font-size: 12px;
  color: #564C47;
  img {
    display: block;
    width: 1.5em;
  }
}
.ForwardPosterBox {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #FFFFFF;
  background-color: #DB1F15;
  border-radius: 20px 0 0 20px;
  .relayIcon {
    display: block;
    width: 14px;
    margin-right: 4px;
  }
  .newGif {
    width: 30px;
    position: absolute;
    right: 0px;
    bottom: 17px;
  }
}

.content1 {
  width: 90%;
  margin: auto;
  margin-top: 12px;
}

.content2 {
  width: 90%;
  margin: auto;
  margin-top: 12px;
}

/deep/ .content1 img {
  display: block;
}

/deep/ .content2 img {
  display: block;
}

/deep/ .content1 video {
  width: 100%;
  height: 190px;
}

/deep/ .content2 video {
  width: 100%;
  height: 190px;
}

.anchorPointBox {
  width: 100%;
  padding: 10px;
  background-color: #FFFFFF;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
  margin: 15px 0;
  box-sizing: border-box;
  .anchorPointWrapper {
    width: 100%;
    overflow-x: scroll;
  }
  .anchorPointWrapper::-webkit-scrollbar { display: none; }
  .anchorPointList {
    display: inline-block;
    white-space: nowrap;
    .anchorPoint_item {
      display: inline-block;
      border: 1px solid transparent;
      border-radius: 6px;
      background: linear-gradient(#fff, #fff) padding-box,
      linear-gradient(to right, #EB1700 40%, #C33BBB 60%, #8C3BBB 100%) border-box;
      padding: 7px;
      background-clip: padding-box, border-box;
      background-origin: padding-box, border-box;
      overflow: hidden;
      .anchorPoint_item_content {
        display: flex;
        align-items: center;
        // margin: 7px;
        font-size: 12px;
        color: #EB1700;
      }
      .anchorPoint_icon {
        display: block;
        width: 11px;
        margin-right: 6px;
      }
      .anchorPoint_time {
        margin-right: 6px;
      }
      .anchorPoint_title {
        position: relative;
        display: inline-block;
        max-width: 135px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .anchorPoint_item:not(:last-of-type) {
      margin-right: 8px;
    }
    .anchorPoint_item_active {
      background: linear-gradient(120deg, #EB1700 30%, #C33BBB 80%, #8C3BBB 100%) padding-box,
      linear-gradient(120deg, #EB1700 30%, #C33BBB 80%, #8C3BBB 100%) border-box;
      .anchorPoint_icon {
        width: 14px;
      }
      .anchorPoint_item_content {
        color: #FFFFFF;
      }
    }
  }
}

.detail {
  margin: auto;
  padding-bottom: 1em;
  img {
    margin: 0.8em 0;
  }
}

/deep/ .Desc > p > img {
  width: 100%;
}

/deep/ .VContent > p > img {
  width: 100%;
}

/deep/ .VContent img {
  width: 100%;
}

/deep/ section {
  width: 100%;
  img {
    width: 100% !important;
    height: auto !important;
  }
  p {
    img {
      width: 100% !important;
      height: auto !important;
    }
  }
}

.banner {
  /deep/ p {
    img {
      width: 100% !important;
      height: auto !important;
    }
  }
}

.rateupload {
  border: 0;
  width: 100px;
  height: 36px;
  line-height: 36px;
  border-radius: 36px;
  text-align: center;
  margin: 20px auto 0;
  background-image: url('../../assets/images/btn_bg1.png');
  background-size: 100% 100%;
  font-size: 14px;
  color: #FFFFFF;
}

.rowbtn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  margin: 20px auto;
  color: #CA001A;
  .headline {
    font-size: 16px;
    font-weight: bold;
  }
}

.plbtn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 22px;
  line-height: 22px;
  color: #CA001B;
  font-size: 14px;
  font-weight: bold;
  background-image: url('../../assets/images/comment_bg.png');
  background-size: 100% 100%;
  padding-left: 16px;
  box-sizing: border-box;
}

.plmain {
  width: 90%;
  margin: auto;
}

.plrow {
  position: relative;
  margin-bottom: 1em;
}

.tx {
  display: inline-block;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  overflow: hidden;
  vertical-align: middle;
  img {
    width: 100%;
    display: block;
  }
}

.plname {
  display: inline-block;
  font-size: 14px;
  margin-left: 0.5em;
  color: #999999;
}

.pltop {
  position: relative;
}

.pltime {
  position: absolute;
  right: 0;
  font-size: 12px;
  top: 22%;
  color: #999999;
}

.pltext {
  font-size: 14px;
  color: #333333;
  padding-left: 34px;
}

.pldz {
  margin-left: 34px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-bottom: 1px solid #EEEEEE;
  padding-bottom: 12px;
  img {
    width: 14px;
    height: 14px;
  }
  span {
    margin-left: 4px;
    color: #333333;
    font-size: 12px;
  }
}

.ssicon {
  font-size: 11px !important;
  vertical-align: middle;
  img {
    vertical-align: baseline !important;
  }
}

.bottombar {
  position: fixed;
  bottom: 0;
  background: #fff;
  width: 100%;
  text-align: center;
  padding-bottom: 1.5em;
  padding-top: 0.5em;
  z-index: 99;
}

.toTop {
  position: fixed;
  right: 13px;
  bottom: 60px;
  width: 40px;
  height: 40px;
  text-align: center;
  padding-bottom: 1.5em;
  padding-top: 0.5em;
  z-index: 999;
  a {
    scroll-behavior: smooth;
    img {
      width: 100%;
      height: 100%;
    }
  }
}

.gobackXG {
  position: fixed;
  right: 2px;
  bottom: 200px;
  width: 72px;
}

.xcpsy {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  bottom: 135px;
  right: 8px;
  img {
    width: 40px;
    height: 40px;
    margin-bottom: 5px;
  }
  span {
    font-size: 10px;
    color: #CA001B;
  }
}

.pluswj {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  bottom: 205px;
  right: 18px;
  .iconBox {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    margin-bottom: 3px;
  }
  img {
    width: 40px;
    height: 40px;
  }
  span {
    font-size: 10px;
    color: #CA001B;
  }
}

.bottomrow {
  display: inline-block;
  width: 25%;
}

.bottomimg {
  width: 1.5em;
}

.bottomtext {
  font-weight: bold;
  font-size: 0.9em;
}

.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  // padding-bottom: 1.5em;
  // padding-top: 1em;
  text-align: center;
  // background-color: #f9f9f9;
  border-radius: 10px;
  img {
    // width: 90% !important;
    width: 100%;
  }
}

.custom-indicator {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0.3rem;
  padding: 2px 5px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
  padding: 0.5em 1.5em;
  border-radius: 5em;
}

.disable {
  background: #C3C3C3;
}

.bannertop {
  position: absolute;
  top: 3%;
  left: 2.5%;
  font-weight: bold;
}

.plPopup {
  padding-top: 3em;
}

.plinput {
  margin: auto;
  margin-bottom: 2em;
  width: 90%;
  border: 1px solid #CA001B;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 1em;
}

.shlog {
  width: 100%;
  height: 100%;
  position: fixed;
  background: rgba(0, 0, 0, 0.8);
  z-index: 99999;
  .shin {
    position: fixed;
    width: 100%;
    top: 20px;
    left: 0;
    .shlog1 {
      display: block;
      width: 16%;
      margin: 0 auto;
      margin-top: 0.3rem;
      margin-right: 9%;
    }
    .shlog2 {
      width: 61%;
      display: block;
      margin: 0 auto;
      margin-top: 1rem;
      margin-bottom: 1rem;
    }
    .shlog3 {
      color: #fff;
      font-size: 16px;
      width: 70%;
      margin: 0 auto;
    }
    .sslog {
      width: 22px;
      margin-right: 5px;
      vertical-align: middle;
    }
    .sslog1 {
      vertical-align: middle;
      width: 22px;
      margin: 0 5px;
    }
    span {
      vertical-align: middle;
    }
    .shlog4 {
      color: #fff;
      font-size: 16px;
      margin: 0 auto;
      margin-bottom: 0.5rem;
      width: 70%;
    }
    .known {
      width: 56%;
      text-align: center;
      margin: 0 auto;
      background: rgba(255, 255, 255, 0.1);
      border: 2px dashed #fff;
      border-radius: 5px;
      padding: 10px;
      margin-top: 1rem;
    }
  }
}

.noComment {
  text-align: center;
  img {
    width: 180px;
    margin-bottom: 20px;
  }
  span {
    display: block;
    font-size: 12px;
    color: #CCCCCC;
  }
}

.competitionBox {
  width: 90%;
  margin: 20px auto;
  .tips1 {
    font-size: 16px;
    color: #333333;
    text-align: center;
    margin-bottom: 10px;
  }
  .tips2 {
    font-size: 12px;
    color: #CCCCCC;
  }
}
.videoPopupBox .van-popup--center {
  width: 100%;
}
.videoPopupBox .van-overlay {
  // background-color: rgba(0,0,0, 1) !important;
  background-color: black;
}

.sourceBox {
  width: 90%; 
  margin: 0 auto 15px;
  .sourceTips {
    font-size: 12px;
    margin-bottom: 10px;
    color: #6e6e6e;
  }
  .sourceFlexBox {
    width: 100%;
    display: flex;
    align-items: center;
    background: #F4F4F4;
    color: #606060;
    padding: 1em;
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
    box-sizing: border-box;
  }
  .sourceLogo {
    display: block;
    width: 40px;
    height: 40px;
  }
  .sourceTitle {
    flex: 1;
    margin: 0 15px;
  }
  .sourceIcon {
    flex-shrink: 0;
    width: 8px;
    height: 14px;
  }
}

.speakerBox {
  display: flex;
  width: 90%; 
  margin: 15px auto;
  color: #564C47;
  .speakerIcon {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.4) 0px 0px 4px 0px;
    margin-right: 12px;
    overflow: hidden;
    img {
      display: block;
      width: 100%;
    }
  }
  .speakerInfo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .speakerName {
      font-size: 16px;
      font-weight: bold;
    }
    .positionalName {
      font-size: 11px;
      background-color: #EAEAEA;
      padding: 1px 2px;
      margin-left: 10px;
    }
    .speakerHospital {
      font-size: 14px;
      margin-top: 5px;
    }
  }
}

.PosterPopup {
  width: 90%;
  height: 350px;
  border-radius: 14px;
  overflow-y: visible;
  .close {
    position: absolute;
    top: -7px;
    right: -7px;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 50%;
    background-image: linear-gradient(130deg, #EB1700 50%, #C33BBB 80%, #8C3BBB 100%);
    z-index: 99;
    .closeIcon {
      color: #FFFFFF;
    }
  }
  .PosterBox {
    position: relative;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    border-radius: 14px;
    .generateImageBox {
      padding-bottom: 10px;
    }
    .PosterImg {
      display: block;
      width: 100%;
    }
    .QrcodeBox {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 10px;
      .QrcodeFont {
        width: 60px;
      }
    }
    .Qrcode {
      display: block;
      width: 100px;
      margin: 0 30px ;
    }
    .PosterPhoto {
      display: block;
      width: 100%;
    }
    .tips {
      font-size: 13px;
      color: #333333;
      text-align: center;
      margin: 0 0 18px;
    }
  }
}

.relatedRecommendation {
  width: 90%;
  margin: 0 auto;
  .relatedTitle {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    color: #CA001A;
    padding: 10px 0;
    .icon {
      display: block;
      width: 15px;
      margin-right: 4px;
    }
  }
  .relatedContent {
    background-color: #FFFFFF;
    box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
    border-radius: 8px;
    padding: 10px 6px;
    box-sizing: border-box;
    margin-bottom: 10px;
    .articleList {
      display: flex;
      .articleCover {
        position: relative;
        width: 40%;
        border-radius: 6px;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
        }
        .sourceTag {
          position: absolute;
          top: 0;
          left: 0;
          min-width: 50px;
          height: 16px;
          line-height: 16px;
          text-align: center;
          font-size: 8px;
          color: #FFFFFF;
          background-image: linear-gradient(to right, #EB1700 0%, #C33BBB 50%, #8C3BBB 100%);
          border-radius: 0 0 8px 0;
          padding: 0 4px;
          box-sizing: border-box;
        }
      }
      .articleInfo {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 60%;
        padding-left: 8px;
        box-sizing: border-box;
        color: #564C47;
        .articleTitle {
          font-size: 14px;
          line-height: 18px;
        }
        .articleData {
          .operateBox {
            display: flex;
            justify-content: flex-end;
            align-items: center;
          }
          .operateItem {
            display: flex;
            align-items: center;
            font-size: 12px;
            margin-left: 10px;
          }
          .operateIcon {
            display: block;
            width: 12px;
            margin-right: 2px;
          }
          .watch {
            width: 13px;
          }
          .like {
            width: 11px;
          }
          .collect {
            width: 11px;
          }
        }
      }
    }
    .articleList:not(:last-of-type) {
      margin-bottom: 10px;
    }
  }
}
</style>